import {
  createStyles,
  FormGroup,
  FormHelperText,
  makeStyles,
  Theme,
} from "@material-ui/core";

import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";

import { useField } from "formik";
import {
  OthersIcon,
  RemoteDataCollectionIcon,
  TranscribeIcon,
  TranslateIcon,
  VoiceIcon,
  WritingIcon,
} from "src/images/services";

const toggleGroupStyles = makeStyles((theme: Theme) =>
  createStyles({
    toggle_group: {
      flexWrap: "wrap",
      justifyContent: "center",
      gap: "1em",
      "& svg": {
        fill: "inherit",
        stroke: "inherit",
        maxWidth: 50,
        maxHeight: 50,
      },
      "& .Mui-selected": {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        "& svg": {
          fill: "white",
          stroke: "white",
        },
      },
      "& .Mui-selected:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
      "& .MuiToggleButton-label": {
        display: "block",
      },
      "& button.MuiToggleButton-root": {
        border: "1px solid #00000030",
        borderRadius: 5,
      },
    },
    tos: {
      "& a": {
        color: theme.palette.primary.main,
        textDecoration: "none",
      },
    },
  })
);

enum Services {
  TRANSLATION = "TRANSLATION",
  TRANSCRIPTION = "TRANSCRIPTION",
  WRITING = "WRITING",
  RDC = "REMOTE_DATA_COLLECTION",
  VOICE = "VOICE_RECORDING",
  OTHER = "OTHER",
}

export default function ServicesFormGroup(props) {
  const [field, meta, helper] = useField(props.field);
  const classes = toggleGroupStyles(meta);
  const _onChange = (e: any, v: any) => {
    helper.setTouched(true);
    helper.setValue(v);
  };

  return (
    <FormGroup style={{ margin: "1em" }}>
      <FormHelperText id="services-helper" style={{ fontSize: "1.5em" }}>
        What services do you need?
      </FormHelperText>
      <ToggleButtonGroup
        value={field.value}
        onChange={_onChange}
        aria-label="Select services"
        className={classes.toggle_group}
      >
        <ToggleButton
          autoFocus
          value={Services.TRANSLATION}
          aria-label="Translation"
        >
          <TranslateIcon />
          <br />
          Translation
        </ToggleButton>
        <ToggleButton value={Services.TRANSCRIPTION} aria-label="Transcription">
          <TranscribeIcon />
          <br />
          Transcription
        </ToggleButton>
        <ToggleButton
          value={Services.WRITING}
          aria-label="Writing and Communicatinos"
        >
          <WritingIcon />
          <br />
          Writing &amp; Communications
        </ToggleButton>
        <ToggleButton value={Services.RDC} aria-label="Remote Data Collection">
          <RemoteDataCollectionIcon />
          <br />
          Remote Data Collection
        </ToggleButton>
        <ToggleButton value={Services.VOICE} aria-label="Voice Recording">
          <VoiceIcon />
          <br />
          Voice Recording
        </ToggleButton>
        <ToggleButton value={Services.OTHER} aria-label="Others">
          <OthersIcon />
          <br />
          Others
        </ToggleButton>
      </ToggleButtonGroup>

      <FormHelperText className="Mui-error">
        {meta.touched && meta.error}
      </FormHelperText>
    </FormGroup>
  );
}
